import React from 'react'
import { CaseStudySummary, CaseStudyStats } from '../../api/Types'
import YouTube from '../../../views/home/machine_builder/Youtube'
import CaseStudyStat from '../../common/case_studies/CaseStudyStat'
import TalkToExpertButton from '../../../common/TalkToExpertButton'

interface Props {
  headerTitle?: string
  title?: string
  company?: string
  summary?: CaseStudySummary
  stats?: CaseStudyStats
  documentFile?: string
  documentFileLabel?: string
}

export const DEFAULT_SPEC_NAMES = {
  completed_in: 'Completed in',
  design_time: 'Design time',
  assembly_time: 'Assembly time',
  commissioning: 'Commissioning',
}

const DocsCaseStudySummaryStats: React.FunctionComponent<Props> = ({
  headerTitle,
  title,
  company,
  summary,
  stats,
  documentFile,
  documentFileLabel,
}) => {
  const HeadingTag = title ? 'h3' : 'h2'

  return (
    <>
      {summary && (
        <div className='case-study-summary'>
          <div className='case-study-summary-container'>
            <div className='case-study-summary-text'>
              {title && (
                <>
                  <h2 className='case-study-summary-header'>
                    {headerTitle || 'Client Case Study'}
                    <span className='case-study-summary-company'>{company}</span>
                    <span className='case-study-summary-title'>{title}</span>
                  </h2>
                </>
              )}
              <HeadingTag className='case-study-summary-text-title'>The Company</HeadingTag>
              <p className='case-study-summary-text-desc'>{summary.company}</p>
              <HeadingTag className='case-study-summary-text-title'>The Challenge</HeadingTag>
              <p className='case-study-summary-text-desc'>{summary.challenge}</p>
              <HeadingTag className='case-study-summary-text-title'>The Solution</HeadingTag>
              <p className='case-study-summary-text-desc'>{summary.solution}</p>

              <div className='case-study-summary-cta-wrapper'>
                <TalkToExpertButton
                  className='case-study-summary-cta'
                  trackingKey='book_meeting_case_study_summary'
                  noIcon={true}
                />
                {documentFile && (
                  <a
                    className='case-study-summary-document-file'
                    href={documentFile}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {documentFileLabel || 'Download Case Study'}
                  </a>
                )}
              </div>
            </div>
            {!!summary.youtube_id ||
              (!!summary.image_url && (
                <div className='case-study-summary-video'>
                  {summary.youtube_id ? (
                    <YouTube video={`https://www.youtube.com/embed/${summary.youtube_id}`} />
                  ) : summary.image_url ? (
                    <img src={summary.image_url} alt={title} loading='lazy' />
                  ) : null}
                </div>
              ))}
          </div>
        </div>
      )}
      {stats && (
        <div className='case-study-stats'>
          <div className='case-study-stats-container'>
            <ul className='case-study-stats-list'>
              {stats.completed_in && (
                <li>
                  <CaseStudyStat
                    stat={stats.completed_in}
                    defaultLabel='days'
                    defaultHeading={DEFAULT_SPEC_NAMES.completed_in}
                    HeadingTag={HeadingTag}
                  />
                </li>
              )}
              {stats.design_time && (
                <li>
                  <CaseStudyStat
                    stat={stats.design_time}
                    defaultHeading={DEFAULT_SPEC_NAMES.design_time}
                    HeadingTag={HeadingTag}
                  />
                </li>
              )}
              {stats.assembly_time && (
                <li>
                  <CaseStudyStat
                    stat={stats.assembly_time}
                    defaultHeading={DEFAULT_SPEC_NAMES.assembly_time}
                    HeadingTag={HeadingTag}
                  />
                </li>
              )}
              {stats.commissioning && (
                <li>
                  <CaseStudyStat
                    stat={stats.commissioning}
                    defaultHeading={DEFAULT_SPEC_NAMES.commissioning}
                    HeadingTag={HeadingTag}
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}

export default DocsCaseStudySummaryStats
